import React, { useState, useRef } from 'react';
import ReportIcon from '@material-ui/icons/Report';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import snapfix_icon from '../images/snapfix_icon.png'
import { DropzoneArea } from 'material-ui-dropzone';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { IconButton } from '@material-ui/core';
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";
import moment from 'moment';
import saveImage from '../Services/saveImage';
import not_found from '../images/not-found.png'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: '18px',
    },
  }));

const OptionalPage = ({ logo,image, title }) => {
    const classes = useStyles();

    const imageValue = useRef(null);
    const secondLogoValue = useRef(null);
    const { secondTitle, setSecondTitle } = title;
    const { optionalImage,setOptionalImage} = image;
    const { optionalLogo,setOptionalLogo} = logo;
    const [inProgress,setInProgress] = useState(false);
    const [onLoad, setOnLoad] = useState(null);

    const uploadNewImage = async (uploadedFile) => {
        if(!uploadedFile){return};
        setOnLoad(true);
        await saveImage(uploadedFile)
            .then(res => {
                if (res.image_url) {
                    setOptionalImage(res.image_url);
                    setOnLoad(false)
                } else {
                    toast.error('Something went wrong');
                }
            })
    };
    const uploadNewLogo = async (logo) => {
        if(!logo){return};
        setInProgress(true);
        await saveImage(logo)
        .then(res => {
            if (res.image_url) {
                setOptionalLogo(res.image_url);
                setInProgress(false)
            } else {
                toast.error('Something went wrong');
            }
        })
    };

    return (
        <div className="optional-snapboard">
            <div className="snapboard-header-part">
                <div className="left-part">
                    <div className="h4">
                        <h4 className="required">
                            SNAPBOARD TITLE
                        </h4>
                        <Tooltip 
                            title="You can set an alternative Title for screen two. If left blank it will default to the title of the main screen."
                            classes={{ tooltip: classes.title }}
                        >
                            
                            <ReportIcon style={{ color: '#0d7cf5' }} />
                        </Tooltip>
                    </div>

                    <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Enter the Snapboard Title"
                        size="small"
                        value={secondTitle}
                        onChange={(e) => setSecondTitle(e.currentTarget.value)}
                    />
                </div>
                <div className="second-logo-container">
                    {!inProgress ? 
                        <Tooltip 
                        title="You can set an alternative logo for screen two. If left blank it will default to the logo of the main screen."
                        classes={{ tooltip: classes.title }}
                    >
                        <ReportIcon style={{ color: '#0d7cf5' }} />
                    </Tooltip> : null
                    }
                    {!inProgress ?
                        <div
                            className="div-img"
                            style={{ backgroundImage: `url(${!optionalLogo ? not_found : optionalLogo})` }} 
                        /> :
                        <CircularProgress />
                    }

                    <input
                        accept="image/*"
                        style={{ display: 'none', width: 0, height: 0 }}
                        id="upload-snapboard-second-logo"
                        type="file"
                        onChange={() => uploadNewLogo(secondLogoValue.current.files[0])}
                        ref={secondLogoValue}
                    />

                    <label htmlFor="upload-snapboard-second-logo">
                        <IconButton aria-label="upload picture" component="span">
                            <EditOutlinedIcon />
                        </IconButton>
                    </label>
                </div>
            </div>

            <div className="optional-full-screen-image">
                <div className="info">
                    <h4 className="required">Screen Main picture</h4>
                    <Tooltip 
                        title="You can set the second screen image by uploading an image from your computer. Make sure the image is sized and oriented appropriately for the intended monitor and that the file is in an image format (PNG or JPG for example)."
                        classes={{ tooltip: classes.title }}
                    >
                        <ReportIcon style={{ color: '#0d7cf5' }} />
                    </Tooltip>
                </div>
                {!optionalImage && !onLoad ?
                    <DropzoneArea
                        dropzoneText='Drag and drop an image here or click on the cloud icon to choose an image from your computer.'
                        filesLimit={1}
                        maxFileSize={3000000}
                        acceptedFiles={["image/png", "image/jpg", "image/jpeg"]}
                        showPreviews={false}
                        showPreviewsInDropzone={false}
                        showFileNamesInPreview={false}
                        onDrop={uploadedImage => {
                            uploadNewImage(uploadedImage[0])
                        }}
                    /> :
                     onLoad ? <CircularProgress color="primary" /> :

                        <div className="img" style={{ backgroundImage: `url(${optionalImage})` }}>
                            <input
                                accept="image/*"
                                style={{ display: 'none', width: 0, height: 0 }}
                                id="upload-new-file-optional"
                                type="file"
                                onChange={() => uploadNewImage(imageValue.current.files[0])}
                                ref={imageValue}
                            />
                            <label htmlFor="upload-new-file-optional">
                                <IconButton aria-label="upload picture" component="span">
                                    <EditOutlinedIcon />
                                </IconButton>
                            </label>
                        </div> 
                }
            </div>

            <div className="snapboard-footer-part">
                <p>Last updated {moment(new Date().getTime()).format('DD/MM/YYYY HH:mm')}</p>
                <p>Powered by</p>
                <img
                    width="60px"
                    src={snapfix_icon}
                    alt="snapfix-logo"
                    className="snapboard-sf-logo"
                />
            </div>
        </div>
    )
};

export default OptionalPage;
